/* ActivityMaps.js */

"use strict";

// Maps that define how osplan audit records become activity feed rows.
// - ActivityMap: [oldStatus][newStatus] -> row presentation for update audits
// - NewStatusActivityMap: newStatus -> row presentation when there is no before.status
// - RelNounMap: audit relName -> display noun; its keys also drive the
//   relName filter in PagingActivityFeed, so the query and renderer stay in sync

const ActivityMap = {
    DRAFT: {
        VALIDATING: {
            status: "running",
            type: "note",
            msg: "Plan validation started",
            includeUser: true,
        },
    },
    VALIDATING: {
        VALIDATED: {
            status: "success",
            type: "system",
            msg: "The plan was successfully validated",
        },
        INVALID: {
            status: "failed",
            type: "system",
            msg: "The plan did not pass validation",
        },
        VALIDATION_ERROR: {
            status: "error",
            type: "system",
            msg: "An error occurred while running plan validation",
        },
        VALIDATION_CANCELED: {
            status: "failed",
            type: "note",
            msg: "The plan validation was canceled",
            includeUser: true,
        },
    },
    VALIDATED: {
        RUNNING: {
            status: "running",
            type: "note",
            msg: "The plan was started",
            includeUser: true,
        },
        SCHEDULED: {
            status: "clean",
            type: "note",
            msg: "The plan was scheduled to run in the future",
        },
    },
    SCHEDULED: {
        RUNNING: {
            status: "running",
            type: "system",
            msg: "The plan was started by a schedule",
        },
    },
    RUNNING: {
        COMPLETE: {
            status: "success",
            type: "system",
            msg: "The plan completed successfully",
        },
        CANCELED: {
            status: "failed",
            type: "note",
            msg: "The plan was canceled",
            includeUser: true,
        },
        ERROR: {
            status: "failed",
            type: "system",
            msg: "An error occurred while running the plan",
        },
    },
};

// Fallback map keyed by new status only, for audit records that carry no "before" snapshot.
const NewStatusActivityMap = {
    VALIDATING: {
        status: "running",
        type: "note",
        msg: "Plan validation started",
        includeUser: true,
    },
    VALIDATED: {
        status: "success",
        type: "system",
        msg: "The plan was successfully validated",
    },
    INVALID: {
        status: "failed",
        type: "system",
        msg: "The plan did not pass validation",
    },
    VALIDATION_ERROR: {
        status: "error",
        type: "system",
        msg: "An error occurred while running plan validation",
    },
    VALIDATION_CANCELED: {
        status: "failed",
        type: "note",
        msg: "The plan validation was canceled",
        includeUser: true,
    },
    RUNNING: {
        status: "running",
        type: "system",
        msg: "The plan was started",
    },
    SCHEDULED: {
        status: "clean",
        type: "note",
        msg: "The plan was scheduled to run in the future",
    },
    COMPLETE: {
        status: "success",
        type: "system",
        msg: "The plan completed successfully",
    },
    CANCELED: {
        status: "failed",
        type: "note",
        msg: "The plan was canceled",
        includeUser: true,
    },
    ERROR: {
        status: "failed",
        type: "system",
        msg: "An error occurred while running the plan",
    },
};

const RelNounMap = {
    devices: "Device",
    osImages: "Image",
};

module.exports = {ActivityMap, NewStatusActivityMap, RelNounMap};
